import { useSyncExternalStore } from "react";

// "Show system dreams" toggle (superuser debug preference, persisted per
// browser). When on, the sidebar's team and collaborating pools list
// ownerless dreams (`include_ownerless_dreams`, see isOwnerlessDream).

const SHOW_SYSTEM_DREAMS_STORAGE_KEY = "bs:show-system-dreams";

let showSystemDreams: boolean | null = null;
const toggleListeners = new Set<() => void>();

function readShowSystemDreams(): boolean {
  if (showSystemDreams == null) {
    try {
      showSystemDreams =
        typeof window !== "undefined" &&
        window.localStorage.getItem(SHOW_SYSTEM_DREAMS_STORAGE_KEY) === "1";
    } catch {
      showSystemDreams = false;
    }
  }
  return showSystemDreams;
}

export function setShowSystemDreamsDebug(enabled: boolean): void {
  showSystemDreams = enabled;
  try {
    if (enabled) {
      window.localStorage.setItem(SHOW_SYSTEM_DREAMS_STORAGE_KEY, "1");
    } else {
      window.localStorage.removeItem(SHOW_SYSTEM_DREAMS_STORAGE_KEY);
    }
  } catch {
    // Storage unavailable: keep the in-memory value for this tab.
  }
  toggleListeners.forEach((listener) => listener());
}

function subscribeShowSystemDreams(listener: () => void): () => void {
  toggleListeners.add(listener);
  return () => toggleListeners.delete(listener);
}

const getShowSystemDreamsServer = () => false;

export function useShowSystemDreamsDebug(): boolean {
  return useSyncExternalStore(
    subscribeShowSystemDreams,
    readShowSystemDreams,
    getShowSystemDreamsServer,
  );
}
